import { Box, styled, Typography } from '@mui/material';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

export const LoginContainer = styled(Box)(({ theme, isSignup }) => ({
  width: '522px',
  background: theme.palette.mode === 'dark' ? '#222' : '#fff',
  padding: isSignup ? theme.spacing(0, 12) : theme.spacing(6, 12),
  borderRadius: theme.spacing(3.5),

  '& .magicalApi_icon': {
    width: theme.spacing(42),
    margin: '0px auto 2rem auto',
    display: 'block',
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(30),
    },
  },
  [theme.breakpoints.down('xl')]: {
    marginTop: '-50px',
  },
  [theme.breakpoints.down('1024')]: {
    marginTop: '0px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: theme.spacing(0),
  },
}));

export const LoginContainerHeader = styled(Box)(({ theme, isSignup }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: isSignup ? theme.spacing(8) : theme.spacing(0),

  [theme.breakpoints.down('1024')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const LoginContainerLogoWrapper = styled(Box)(({ theme }) => ({
  // display: 'flex',
  // alignItems: 'center',
  // justifyContent: 'space-between',

  [theme.breakpoints.down('1024')]: {
    width: '100%',
    marginBottom: theme.spacing(8),
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginBottom: theme.spacing(6),
  },
}));

export const LoginContainerLogo = styled('img')(({ theme }) => ({
  marginBottom: `0 !important`,
}));

// New component for the right side box (only visible on lg and above)
export const RightSideBox = styled(Box)(({ theme }) => ({
  display: 'none', // Hidden by default
  [theme.breakpoints.up('1024')]: {
    height: 'auto',
    minHeight: '100vh',
    position: 'sticky',
    top: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '50%',
    // height: '100vh',
    backgroundColor: theme.palette.secondary.secondary_10,
    padding: theme.spacing(36, 30, 20),
    '@media (max-height: 800px)': {
      padding: theme.spacing(20, 30),
    },
    [theme.breakpoints.down('xl')]: {
      padding: theme.spacing(30, 24, 18),
      // padding: theme.spacing(30, 24),
    },
    // [theme.breakpoints.down('1300')]: {
    //   padding: theme.spacing(26, 20, 18),
    // },
    [theme.breakpoints.down('1260')]: {
      padding: theme.spacing(31, 14, 18),
    },
  },
}));

// New component for the right side box (only visible on lg and above)
export const LeftSideBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('1024')]: {
    padding: theme.spacing(29, 54, 12),
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const RightSideBoxHeading = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(10.5),
  fontWeight: 600,

  color: '#F9FCFF',
  lineHeight: theme.spacing(13),
  paddingBottom: theme.spacing(2.5),
  span: {
    color: '#FFFFFF',
  },
  [theme.breakpoints.down('xl')]: {
    lineHeight: theme.spacing(11),
    fontSize: theme.spacing(9),
  },
  [theme.breakpoints.down('lg')]: {
    lineHeight: theme.spacing(10),
    fontSize: theme.spacing(8),
  },
}));

export const RightSideBoxTrustedBy = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.spacing(8.5)} !important`,
  fontWeight: 600,
  color: '#F5F5F5',
  margin: '0 !important',
  padding: '0 !important',
  lineHeight: '1 !important',
  [theme.breakpoints.down('xl')]: {
    fontSize: `${theme.spacing(7)} !important`,
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: `${theme.spacing(6.25)} !important`,
  },
}));

export const RightSideBoxSubHeading = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.spacing(4.5)} !important`,
  fontWeight: 500,
  marginBottom: theme.spacing(2),
  color: '#FFFFFF',
  [theme.breakpoints.down('xl')]: {
    fontSize: `${theme.spacing(4)} !important`,
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: `${theme.spacing(3.75)} !important`,
  },
}));

export const RightSideBoxLowerHalf = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: theme.spacing(5),
}));

export const RightSideBoxHeadingContainer = styled(Box)(({ theme }) => ({
  width: '70%',
  [theme.breakpoints.down('xl')]: {},
  [theme.breakpoints.down('1300')]: {},
  [theme.breakpoints.down('1840')]: {
    width: '90%',
  },
  [theme.breakpoints.down('1200')]: {},
}));

export const ChangeLanguageWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  paddingTop: theme.spacing(2),
}));

export const CenterContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center !important',
  alignItems: 'center',
  flexDirection: 'column',
  minHeight: '100vh',
  padding: theme.spacing(6),
  background: theme.palette.mode === 'dark' ? '#222' : '#fff',

  [theme.breakpoints.down('md')]: {
    justifyContent: 'start',
  },
  // Add this section to change layout for lg breakpoint and above
  [theme.breakpoints.up('1024')]: {
    flexDirection: 'row', // Change to row layout for lg and above
    justifyContent: 'space-between',
    padding: 0,
    alignItems: 'stretch', // Use 'stretch' for equal height columns

    '& > div:first-of-type': {
      // Target the first div (LoginContainer wrapper)
      width: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
  },
}));
